module.exports = __webpack_public_path__ + "img/colorful-separator-1.0c40134b.svg";